import React, { useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import pretty from 'pretty-bytes'
import dateFormat from 'date-fns/format'

import Window from '@nocode-works/template/components/dialog/Window'
import Table from '@nocode-works/template/components/table/SimpleTable'
import Guage from 'components/widgets/Guage'
import BarChart from 'components/widgets/BarChart'

import websiteActions from '@nocode-works/template/store/modules/website'
import websiteSelectors from '@nocode-works/template/store/selectors/website'
import quotaSelectors from 'store/selectors/quota'

import icons from '@nocode-works/template/icons'

const DeleteIcon = icons.delete

const QUOTA_FIELDS =[{
  title: 'Type',
  name: 'type',
}, {
  title: 'Allowance',
  name: 'allowance',
}, {
  title: 'Used',
  name: 'used',
}, {
  title: '',
  name: 'guage',
}]

const useStyles = makeStyles(theme => ({
  settings: {
    padding: theme.spacing(4),
  },
  marginTop: {
    marginTop: theme.spacing(4),
  },
  smallText: {
    fontSize: '0.7em'
  },
  paper: {
    padding: theme.spacing(2),
  }
}))

const WebsiteQuota = ({
  
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [ deleteStorageWindowOpen, setDeleteStoageWindowOpen ] = useState(false)

  const website = useSelector(websiteSelectors.websiteData)
  const bandwidthPerDay = useSelector(quotaSelectors.bandwidthPerDay)

  const onReclaimStorage = useCallback(() => {
    dispatch(websiteActions.reclaimStorage(website.id))
  }, [
    website,
  ])

  const monthString = dateFormat(new Date(), 'L/u')

  return (
    <Grid container spacing={ 0 }>
      <Grid item xs={ 12 }>
        <Typography gutterBottom variant="h6">
          Quota
        </Typography>
        <Paper className={ classes.paper }>
          <Table
            data={ [{
              type: 'Storage',
              allowance: website.quota.storage.total.title,
              used: website.quota.storage.used.title,
              guage: <Guage value={ website.quota.storage.percent.value } />
            },{
              type: 'Bandwidth',
              allowance: `${website.quota.bandwidth.total.title} / month`,
              used: website.quota.bandwidth.used.title,
              guage: <Guage value={ website.quota.bandwidth.percent.value } />
            }] }
            fields={ QUOTA_FIELDS }
          />
        </Paper>
      </Grid>
      <Grid item xs={ 12 }>
        <Typography gutterBottom variant="h6" className={ classes.marginTop }>
          Storage usage <span className={ classes.smallText }>({ website.quota.storage.used.title } of { website.quota.storage.total.title })</span>
        </Typography>
        <Paper className={ classes.paper }>
          <Typography gutterBottom variant="body2">
            If you want to free up some storage space, you can delete previous builds of your website.
          </Typography>
          <Typography gutterBottom variant="body2">
            This will not affect the published version of your website but it does mean you cannot rollback to previous versions.
          </Typography>
          <div className={ classes.marginTop }>
            <Button
              size="small"
              variant="outlined"
              onClick={ () => setDeleteStoageWindowOpen(true) }
            >
              <DeleteIcon />&nbsp;&nbsp;Delete previous builds
            </Button>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={ 12 }>
        <Typography gutterBottom variant="h6" className={ classes.marginTop }>
          Bandwidth usage this month <span className={ classes.smallText }>({ website.quota.bandwidth.used.title } of { website.quota.bandwidth.total.title })</span>
        </Typography>

        <Paper className={ classes.paper }>
          <BarChart
            data={ bandwidthPerDay }
            valueFormatter={ pretty }
            labelFormatter={ val => `${val}/${monthString}`}
            valueTitle="usage"
          />
        </Paper>
      </Grid>
      {
        deleteStorageWindowOpen && (
          <Window
            open
            withCancel
            title="Delete previous builds?"
            cancelTitle="Close"
            submitTitle="Confirm - delete previous builds"
            size="sm"
            onSubmit={ () => {
              setDeleteStoageWindowOpen(false)
              onReclaimStorage()
            }}
            onCancel={ () => setDeleteStoageWindowOpen(false) }
          >
            <Typography gutterBottom>
              Are you <strong>absolutely sure</strong> you want to delete the previous builds of your website?
            </Typography>
            <Typography gutterBottom>
              This will reclaim storage space but it does mean you cannot rollback to previous versions.
            </Typography>
          </Window>
        )
      }
    </Grid>
  )
}

export default WebsiteQuota